<div *ngIf="!displayMobileView" class="content-table-pointer">
  <ion-row class="content gray-md-rows color-black" (click)="onEdit($event)">
    <ion-col
      [attr.size]="hideUser ? '3' : '2'"
      class="bold"
      [ngClass]="{ italic: row.company }"
    >
      <ng-container *ngIf="row.company">
        {{ row.company.name }}
      </ng-container>
      <ng-container *ngIf="!row.company">
        {{ "SPACE.ALL_COMPANIES" | translate }}
      </ng-container>
    </ion-col>
    <ion-col size="3" *ngIf="!hideUser" [class]="row.group ? 'bold' : 'italic'">
      <ng-container *ngIf="row.group">
        {{ row.group.name }}
      </ng-container>
      <ng-container *ngIf="!row.group">
        {{ "SPACE.ALL_GROUPS" | translate }}
      </ng-container>
    </ion-col>
    <ion-col size="3" *ngIf="!hideUser" [class]="row.user ? 'bold' : 'italic'">
      <ng-container *ngIf="row.user">
        {{ row.user.firstName }} {{ row.user.lastName }}
      </ng-container>
      <ng-container *ngIf="!row.user">
        {{ "SPACE.ALL_USERS" | translate }}
      </ng-container>
    </ion-col>
    <ion-col [attr.size]="hideUser ? '4' : '3'">
      {{ row.dateFrom | dateSti }}
    </ion-col>
    <ion-col [attr.size]="hideUser ? '4' : '3'">
      {{ row.dateTo | dateSti }}
    </ion-col>
    <ion-col *ngIf="permissionEdit" class="add-remove-col" size="1">
      <div class="ion-text-center">
        <ion-button type="close" size="medium" (click)="onDelete($event)">
          <ion-icon name="close" size="medium"></ion-icon>
        </ion-button>
      </div>
    </ion-col>
  </ion-row>
</div>

<ion-card
  *ngIf="displayMobileView"
  class="content-card-noborder space-assignment-view__mobile-container"
  (click)="onEdit($event)"
>
  <ion-card-header class="space-assignment-view__mobile-header">
    <ion-card-title *ngIf="row.company; else All">
      {{ row.company.name }}
    </ion-card-title>
    <ng-template #All>
      <ion-card-title>
        {{ "SPACE.ALL_USERS" | translate }}
      </ion-card-title>
    </ng-template>

    <ion-card-subtitle *ngIf="!hideUser">
      <ng-container *ngIf="row.group">
        {{ row.group.name }}
      </ng-container>
      <ng-container *ngIf="!row.group">
        {{ "SPACE.ALL_GROUPS" | translate }}
      </ng-container>
    </ion-card-subtitle>
    <ion-card-subtitle *ngIf="!hideUser">
      <ng-container *ngIf="row.user">
        {{ row.user.firstName }} {{ row.user.lastName }}
      </ng-container>
      <ng-container *ngIf="!row.user">
        {{ "SPACE.ALL_USERS" | translate }}
      </ng-container>
    </ion-card-subtitle>
    <ion-button
      *ngIf="permissionEdit"
      type="close"
      size="medium"
      (click)="onDelete($event)"
      class="space-assignment-view__mobile-delete"
    >
      <ion-icon name="close" size="medium"></ion-icon>
    </ion-button>
  </ion-card-header>

  <ion-card-content class="space-assignment-view__mobile-content">
    <ion-grid class="no-padding-grid booking-mobile">
      <ion-row>
        <ion-col class="space-assignment-view__mobile-dates-label">
          <span>
            {{ "SPACE.ASSIGNMENT_START" | translate }}
          </span>
          <span>
            {{ "SPACE.ASSIGNMENT_END" | translate }}
          </span>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col
          class="display-flex ion-align-items-center ion-justify-content-between"
        >
          <div
            class="space-assignment-view__mobile-dot space-assignment-view__mobile-dot--start"
          ></div>
          <div class="space-assignment-view__mobile-separator"></div>
          <div
            class="space-assignment-view__mobile-dot space-assignment-view__mobile-dot--end"
          ></div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="space-assignment-view__mobile-dates-container">
          <span>
            {{ row.dateFrom | dateSti }}
          </span>
          <span>
            {{ row.dateTo | dateSti }}
          </span>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
